export default __webpack_public_path__ + "static/media/mobile-mockup.5733d46c.svg";